var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.40725 14.9083L4.03407 18.457C3.88683 18.5543 3.68862 18.5137 3.59137 18.3665C3.54052 18.2895 3.52544 18.1943 3.55001 18.1053L5.26463 11.8985C5.29871 11.7752 5.25589 11.6434 5.1558 11.5636L0.120374 7.55001C-0.0176171 7.44002 -0.0403178 7.23899 0.0696708 7.101C0.127185 7.02884 0.213087 6.98507 0.30527 6.98096L6.73814 6.69365C6.866 6.68794 6.97811 6.60648 7.02306 6.48665L9.28417 0.457405C9.34613 0.29218 9.53031 0.208469 9.69553 0.270433C9.78193 0.302834 9.8501 0.371007 9.8825 0.457405L12.1436 6.48665C12.1886 6.60648 12.3007 6.68794 12.4285 6.69365L18.8614 6.98096C19.0377 6.98883 19.1742 7.13812 19.1663 7.31441C19.1622 7.40659 19.1185 7.49249 19.0463 7.55001L14.0109 11.5636C13.9108 11.6434 13.868 11.7752 13.902 11.8985L15.6167 18.1053C15.6637 18.2754 15.5639 18.4514 15.3938 18.4984C15.3048 18.523 15.2096 18.5079 15.1326 18.457L9.75942 14.9083C9.65263 14.8378 9.51405 14.8378 9.40725 14.9083Z",
    fill: "#F5B000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.3bcf04b542c09721d314b5ef01d3c8c1.svg";
export { ForwardRef as ReactComponent };